<template>
    <brick-base class="brick-circle" @mouseup="$emit('mouseup', $event)">
        <slot />
    </brick-base>
</template>

<script>
    import BrickBase from './BrickBase.vue';

    export default {
        name: 'brick-circle-base',
        components: {
            BrickBase
        }
    }
</script>

<style scoped src="../Style/brick-circle-base.scss" lang="scss" />